import React, { memo, useContext } from 'react';
import classnames from 'classnames';

import { Drawer } from '../material-ui/Drawer';
import { SidebarContent } from './SidebarContent';
import { SidebarContext } from '../PageLayout/ContextProvider';
import { useStyles } from './useStyles';

import './Sidebar.scss';

export const Sidebar = memo(({ navigationBarVisibility }) => {
    const {
        sidebarVisibility: { navigationPanelVisibility },
    } = useContext(SidebarContext);

    const classes = useStyles();

    return (
        <Drawer
            open={navigationPanelVisibility}
            anchor="left"
            variant="permanent"
            className={classnames(classes.drawerClass, {
                [classes.drawerOpenClass]: navigationPanelVisibility,
                [classes.drawerCloseClass]: !navigationPanelVisibility,
            })}
            classes={{
                paper: classnames(
                    {
                        [classes.drawerOpenClass]: navigationPanelVisibility,
                        [classes.drawerCloseClass]: !navigationPanelVisibility,
                    },
                    classes.drawerPaper,
                    navigationBarVisibility && classes.drawerPaddingBottom
                ),
            }}
        >
            <SidebarContent />
        </Drawer>
    );
});

Sidebar.displayName = 'Sidebar';
